import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { func, shape } from "prop-types";

import { Box, Button, Text } from "@ui-kit/components/index.es";
import { actions as layoutActions } from "reducers/layout";
import * as i18n from "util/i18n";

const HEADER_KEY = "recoveryPassword.step2.disclaimer.header";
const MESSAGE_KEY = "recoveryPassword.step2.disclaimer.message";

function RecoveryInformationV3({ dispatch, history }) {
    useEffect(() => {
        dispatch(layoutActions.setScopes(["recoveryPassword"]));
        return () => {
            dispatch(layoutActions.setScopes([]));
        };
    }, [dispatch]);

    const handleGoToLogin = useCallback(() => {
        history.push("/v3/login");
    }, [history]);

    return (
        <Box flex column gap={24} w="100%">
            <Text as="h2" variant="h3" color="white">
                {i18n.get(HEADER_KEY)}
            </Text>
            <Box
                as="div"
                css={{
                    color: "white",
                    "& a": { color: "white", textDecoration: "underline" },
                }}>
                {/* eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{ __html: i18n.get(MESSAGE_KEY) }} />
            </Box>
            <Button
                text={i18n.get("global.button.signout")}
                aria-label={i18n.get("global.button.signout")}
                variant="solid"
                color="primary"
                rounded
                withShadow
                disabledWhite
                onClick={handleGoToLogin}
            />
        </Box>
    );
}

RecoveryInformationV3.propTypes = {
    dispatch: func.isRequired,
    history: shape({ push: func }).isRequired,
};

export default connect()(RecoveryInformationV3);
